export default __webpack_public_path__ + "static/media/tokenomic.a7d407f3.png";